<div class="flexrow1" style="overflow-y:auto;">

  <div style="padding:1em;" *ngIf="debuginfo$ | async as debuginfo">
    soortZittingIdsAtHome = <span *ngFor="let id of debuginfo.soortZittingIdsAtHome">{{id}},</span> <br />
    soortZittingIds= <span *ngFor="let id of debuginfo.soortZittingIds">{{id}},</span><br />
    userId = {{debuginfo.userId}}
  </div>

  <!-- <h1>Headings and paragraphs</h1>
  <h2>Lorem ipsum, dolor sit amet consectetur adipisicing elit. </h2>
  <div style="width:500px;">
    <p>Donec nec justo eget felis facilisis fermentum. Aliquam porttitor mauris sit amet orci. Aenean dignissim
      pellentesque felis.</p>
    <p>Morbi in sem quis dui placerat ornare. Pellentesque odio nisi, euismod in, pharetra a, ultricies in, diam. Sed
      arcu. Cras consequat.</p>
  </div>
  <h3>Lorem ipsum dolor sit amet consectetur, adipisicing elit.</h3>
  <h4>Lorem ipsum dolor sit amet consectetur, adipisicing elit.</h4>

  <ul>
    <li>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. <span class="date">21/09/2017</span> </li>
    <li>Aliquam tincidunt mauris eu risus <span class="date">21/09/2017</span></li>
    <li>Vestibulum auctor dapibus neque. <span class="date">21/09/2017</span></li>
    <li>Nunc dignissim risus id metus. <span class="date">21/09/2017</span></li>
  </ul>

  <br />
  <button class="btn btn-default">default</button>
  <button class="btn btn-primary">primary</button>

  <div class="icons__panel">

    <div><i class="icon-external-link"></i><span>icon-external-link</span> </div>
    <div><i class="icon-notities-filled"></i><span>icon-notities-filled</span> </div>
    <div><i class="icon-udecided-circle"></i><span>icon-udecided-circle</span> </div>
    <div><i class="icon-agree"></i><span>icon-agree</span> </div>
    <div><i class="icon-agree-circle"></i><span>icon-agree-circle</span> </div>
    <div><i class="icon-agree-filled"></i><span>icon-agree-filled</span> </div>
    <div><i class="icon-arrow_dwn"></i><span>icon-arrow_dwn</span> </div>
    <div><i class="icon-arrow_left"></i><span>icon-arrow_left</span> </div>
    <div><i class="icon-arrow_right"></i><span>icon-arrow_right</span> </div>
    <div><i class="icon-arrow_up"></i><span>icon-arrow_up</span> </div>
    <div><i class="icon-bin"></i><span>icon-bin</span> </div>
    <div><i class="icon-close"></i><span>icon-close</span> </div>
    <div><i class="icon-disagree"></i><span>icon-disagree</span> </div>
    <div><i class="icon-disagree-circle"></i><span>icon-disagree-circle</span> </div>
    <div><i class="icon-disagree-filled"></i><span>icon-disagree-filled</span> </div>
    <div><i class="icon-file"></i><span>icon-file</span> </div>
    <div><i class="icon-filter"></i><span>icon-filter</span> </div>
    <div><i class="icon-home"></i><span>icon-home</span> </div>
    <div><i class="icon-lijst"></i><span>icon-lijst</span> </div>
    <div><i class="icon-link"></i><span>icon-link</span> </div>
    <div><i class="icon-minus"></i><span>icon-minus</span> </div>
    <div><i class="icon-minus-filled"></i><span>icon-minus-filled</span> </div>
    <div><i class="icon-notities"></i><span>icon-notities</span> </div>
    <div><i class="icon-notities-dots"></i><span>icon-notities-dots</span> </div>
    <div><i class="icon-onOff"></i><span>icon-onOff</span> </div>
    <div><i class="icon-options"></i><span>icon-options</span> </div>
    <div><i class="icon-pencil"></i><span>icon-pencil</span> </div>
    <div><i class="icon-pencil-filled"></i><span>icon-pencil-filled</span> </div>
    <div><i class="icon-phone-alert"></i><span>icon-phone-alert</span> </div>
    <div><i class="icon-phone-filled"></i><span>icon-phone-filled</span> </div>
    <div><i class="icon-pin"></i><span>icon-pin</span> </div>
    <div><i class="icon-pin-filled"></i><span>icon-pin-filled</span> </div>
    <div><i class="icon-plus"></i><span>icon-plus</span> </div>
    <div><i class="icon-plus-filled"></i><span>icon-plus-filled</span> </div>
    <div><i class="icon-question"></i><span>icon-question</span> </div>
    <div><i class="icon-refresh"></i><span>icon-refresh</span> </div>
    <div><i class="icon-reply"></i><span>icon-reply</span> </div>
    <div><i class="icon-sort"></i><span>icon-sort</span> </div>
    <div><i class="icon-star"></i><span>icon-star</span> </div>
    <div><i class="icon-star-filled"></i><span>icon-star-filled</span> </div>
    <div><i class="icon-udecided"></i><span>icon-udecided</span> </div>
    <div><i class="icon-undecided-filled"></i><span>icon-undecided-filled</span> </div>
    <div><i class="icon-user"></i><span>icon-user</span> </div>
    <div><i class="icon-user-filled"></i><span>icon-user-filled</span> </div>
    <div><i class="icon-zoom"></i><span>icon-zoom</span> </div>

  </div> -->



</div>